import { Toast, Message, getObject, setObject } from 'larasnap/support';
import merge from 'lodash-es/merge';

const _state = {};

export const loadAppState = (state, options = {}) => {
    handleSystemState(state.__system, options);
    delete state.__system;
    merge(_state, state);
};

export const getState = key => getObject(_state, key);

export const setState = (key, val = null) => setObject(_state, key, val);

const handleSystemState = (state, options = {}) => {
    if (!options.quietly) {
        handleToasts(state.toasts);
        handleMessages(state.messages);
    }

    handleServerLog(state.serverLog);
};

const handleToasts = toasts => {
    toasts.forEach(Toast);
};

const handleMessages = messages => {
    messages.forEach(Message);
};

const handleServerLog = serverLog => {
    if (serverLog.length === 0) {
        return;
    }

    console.log('========================== Server Log ==========================');
    serverLog.forEach(entries => console.log(...entries));
    console.log('================================================================');
};
